import React from 'react';

const SECTIONS = [
  {
    icon: '📊',
    title: 'Overview',
    content: `The Bar Chart visualizes ReadHit metrics grouped by a categorical field — Poly Type, Sequence ID Prefix, or Query Sequence ID. Each bar represents the average or sum of a chosen metric for that group. A secondary metric bar is displayed alongside for comparison.`,
  },
  {
    icon: '⚙️',
    title: 'Controls',
    rows: [
      ['X-Axis',            'Choose the field to group bars by: Poly Type, Sequence ID Prefix, or Query Sequence ID.'],
      ['Primary Metric',    'The main value plotted as bars (e.g. Percent Identity, Bit Score, E-Value).'],
      ['Secondary Metric',  'A second bar rendered side-by-side for comparison (defaults to Count).'],
      ['Use Average',       'Toggle between showing the average or the sum of the metric within each group.'],
      ['Show Value Labels', 'Display the numeric value on top of each bar.'],
    ],
  },
  {
    icon: '🔍',
    title: 'Sorting & Filtering',
    rows: [
      ['Sort By',      'Sort groups by metric value, count, or label (alphabetical).'],
      ['↑ / ↓',        'Toggle ascending or descending sort direction.'],
      ['Filter',       'Type to filter groups by label substring. Pagination resets automatically.'],
      ['Items / page', 'Drag the slider to control how many bars are shown per page (5–50).'],
    ],
  },
  {
    icon: '📏',
    title: 'Reference Line',
    content: `Enter a numeric value in the Reference Line field to draw a horizontal dashed red line across the chart. Useful for marking thresholds such as a minimum acceptable percent identity.`,
  },
  {
    icon: '📄',
    title: 'Pagination',
    content: `When more groups exist than the current items-per-page setting, use the ‹ › arrows above the chart to navigate pages. The total group count and current page are displayed.`,
  },
  {
    icon: '⚠️',
    title: 'Performance',
    content: `The chart automatically limits processing to the first 150,000 rows. A warning banner will appear if your dataset exceeds this limit. Use the Filter control to narrow down groups and improve rendering speed.`,
  },
  {
    icon: '↺',
    title: 'Reset',
    content: `Click the Reset button to restore all controls to their default values: primary metric = Percent Identity, X-axis = Poly Type, 15 items per page, sorted descending by value.`,
  },
];

export default function UserGuideBarChart({ open, onClose }) {
  if (!open) return null;

  return (
    <div className="rh-modal-overlay" onClick={e => e.target === e.currentTarget && onClose()}>
      <div className="rh-modal-box rh-guide-modal" role="dialog" aria-modal="true" aria-labelledby="guide-title-bar">

        <div className="rh-modal-header">
          <div>
            <div className="rh-modal-title" id="guide-title-bar">Bar Chart — User Guide</div>
            <div className="rh-modal-subtitle">How to read and configure the bar chart visualization</div>
          </div>
          <button className="rh-modal-close" onClick={onClose} aria-label="Close">✕</button>
        </div>

        <div className="rh-guide-body">
          {SECTIONS.map((sec, i) => (
            <div key={i} className="rh-guide-section">
              <div className="rh-guide-section-title">
                <span style={{ fontSize: 14, marginRight: 4 }}>{sec.icon}</span>
                {sec.title}
              </div>

              {sec.content && <p className="rh-guide-text">{sec.content}</p>}

              {sec.rows && (
                <table className="rh-guide-table">
                  <tbody>
                    {sec.rows.map(([term, desc]) => (
                      <tr key={term}>
                        <td className="rh-guide-term">{term}</td>
                        <td className="rh-guide-desc">{desc}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              )}
            </div>
          ))}
        </div>

        <div className="rh-modal-footer">
          <button className="rh-btn-close" onClick={onClose}>Close</button>
        </div>
      </div>
    </div>
  );
}
